// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-SupportLogin-styles___supportLoginButton--CQyqx {
  padding: 0 16px;
  background-color: rgb(49, 138, 251);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;
  font-size: 13px;
  margin-left: 16px;
}

.components-SupportLogin-styles___supportLoginButton--CQyqx:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./components/SupportLogin/styles.pcss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".supportLoginButton {\n  padding: 0 16px;\n  background-color: rgb(49, 138, 251);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 32px;\n  font-size: 13px;\n  margin-left: 16px;\n}\n\n.supportLoginButton:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"supportLoginButton": `components-SupportLogin-styles___supportLoginButton--CQyqx`
};
module.exports = ___CSS_LOADER_EXPORT___;
